import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ExternalLinkIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <polygon
                        fill="currentColor"
                        points="17.25 8.27 16.05 8.27 16.07 4.03 11.83 4.04 11.82 2.84 17.27 2.82 17.25 8.27"
                    />
                    <rect
                        fill="currentColor"
                        x="7.97"
                        y="6.53"
                        width="10.19"
                        height="1.2"
                        transform="translate(-1.21 11.33) rotate(-45)"
                    />
                    <polygon
                        fill="currentColor"
                        points="3.49 17.2 3.49 3.6 8.48 3.58 8.48 4.78 4.69 4.79 4.69 16 15.07 15.98 15.07 12.02 16.27 12.02 16.27 17.18 3.49 17.2"
                    />
                    <rect fill="none" width="20" height="20" />
                </g>
            </g>
        </SvgIcon>
    );
};
